import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

const HeroSection = () => {
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated)
    || localStorage.getItem('authenticated') === 'true';

  return (
    <section className="landing-hero">
      <div className="hero-inner">
        {/* Left — text */}
        <div className="hero-text">
          <div className="hero-eyebrow">
            <span className="eyebrow-dot" />
            Smart Building Automation
          </div>

          <h1>
            Enterprise BMS.<br />
            <span>In Your Pocket.</span>
          </h1>

          <p className="hero-subtitle">
            Manzili Smart bridges Siemens Desigo Optic's professional-grade building
            intelligence with a clean, intuitive mobile experience — giving residents
            full control of their environment, from anywhere.
          </p>

          <div className="hero-actions">
            {isAuthenticated ? (
              <Link to="/dashboard" className="hero-btn-primary">Go to Dashboard →</Link>
            ) : (
              <Link to="/login" className="hero-btn-primary">Get Started →</Link>
            )}
            <a href="#how-it-works" className="hero-btn-secondary">See How It Works</a>
          </div>

          <div className="hero-trust">
            <div className="trust-badge">
              <div className="trust-icon">Si</div>
              Powered by Siemens Desigo Optic
            </div>
            <div className="trust-divider" />
            <div className="trust-badge">
              <div className="trust-icon">EP</div>
              Built by EPO Power
            </div>
          </div>
        </div>

        {/* Right — phone mockup */}
        <div className="hero-visual">
          <div className="phone-mockup">
            <div className="phone-notch" />

            <div className="phone-header">
              <div className="phone-app-name">Manzili Smart</div>
              <div className="phone-status">
                <span className="live-dot" />
                <span>Live</span>
              </div>
            </div>

            <div className="phone-room-label">Master Suite · Floor 4</div>

            <div className="phone-cards-row">
              <div className="phone-card active">
                <div className="card-icon">❄️</div>
                <div className="card-label">Temperature</div>
                <div className="card-value teal">22.5°C</div>
                <div className="card-sub">Target: 23°C</div>
              </div>
              <div className="phone-card">
                <div className="card-icon">💡</div>
                <div className="card-label">Lighting</div>
                <div className="card-value">80%</div>
                <div className="card-sub">Warm white</div>
              </div>
            </div>

            <div className="phone-sensor-row">
              <div className="phone-sensor">
                <span className="sensor-name">Fan Speed</span>
                <span className="sensor-val">Medium</span>
              </div>
              <div className="phone-sensor">
                <span className="sensor-name">AC Mode</span>
                <span className="sensor-val">Cool</span>
              </div>
              <div className="phone-sensor">
                <span className="sensor-name">Occupancy</span>
                <span className="sensor-badge">Occupied</span>
              </div>
              <div className="phone-sensor">
                <span className="sensor-name">Humidity</span>
                <span className="sensor-val">47%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
